import { z } from "zod";

export const nameValue = z.object({
  name: z.string(),
  value: z.string(),
});

export type NameValue = z.infer<typeof nameValue>;
